

















































































// import Breadcrumb from '@/components/Breadcrumb/index.vue'
import Breadcrumb from '../../../components/Breadcrumb/index.vue'
import Hamburger from '../../../components/Hamburger/index.vue'
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '../../../store/modules/app'
import { UserModule } from '../../../store/modules/user'
import BaseClass from '../../../virtual-class/baseClass'

@Component({
  components: {
    Breadcrumb,
    Hamburger,
  },
})
export default class Navbar extends BaseClass {
  get sidebar() {
    return AppModule.sidebar
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }

  private logout() {
    UserModule.LoginOut().then(() => {
      // this.$router.push({ name: 'Login' })
      location.reload() // 为了重新实例化vue-router对象 避免bug
    })
  }
}
